import { preview } from '@/components/form/preview'

import { ViewDetails } from '../../components/ViewDetails'
import { Header } from './components/Header'

interface Props {
  driverAssignment: uui.domain.client.rm.DriverAssignmentsWithId
}

export function SingleView(props: Props) {
  const {
    driverAssignment: { id, assignments },
  } = props

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header driverAssignmentId={id} />}>
      <ViewDetails assignments={assignments} />
    </preview.Root>
  )
}
